import React from 'react';

export const FirebaseContext = React.createContext(null);

export default FirebaseContext;